<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <template v-if="templates.length">
        <v-flex
          xs12
        >
          <template-select
            v-model="template"
            :templates="templates"
          />
        </v-flex>
        <v-flex
          v-for="setting of settings"
          :key="setting.id"
          xs12
          md12>

          <v-layout>
            <v-flex xs6>
              <v-switch
                v-if="setting.type === 'switch'"
                v-model="setting.value"
                :label="setting.label"
                :loading="loadingField === setting.id"
                :messages="setting.description || ''"
                @change="save(setting.id, setting.value, setting.label)"
              />

              <v-select
                v-else-if="setting.type === 'select'"
                :label="setting.label"
                :items="setting.options"
                v-model="setting.value"
                :loading="loadingField === setting.id"
                :messages="setting.description || ''"
                outline
                @change="save(setting.id, setting.value, setting.label)"
              />

              <date-picker
                v-else-if="setting.type === 'date_picker'"
                v-model="setting.value"
                :label="setting.label"
                :messages="setting.description || ''"
                :loading="loadingField === setting.id"
                append-icon="event"
                readonly
                @change="save(setting.id, setting.value, setting.label)"
              />

              <color-picker
                v-else-if="setting.type === 'color_picker'"
                v-model="setting.value"
                :label="setting.label"
                :messages="setting.description"
                :loading="loadingField === setting.id"
                outline
                append-icon="palette"
                readonly
                @change="save(setting.id, setting.value, setting.label)"
              />
              <v-text-field
                v-else
                :label="setting.label"
                :type="setting.meta && setting.meta.type ? setting.meta.type : 'text'"
                v-model="setting.value"
                :loading="loadingField === setting.id"
                :messages="setting.description || ''"
                outline
                @change="save(setting.id, setting.value, setting.label)"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </template>
      <v-flex
        v-else
        xs12
        py-4
      >
        <span class="subheading">{{ $t('No templates installed') }}</span>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DatePicker from '@/modules/CMS/components/DatePicker'
import ColorPicker from '@/modules/CMS/components/ColorPicker'
import TemplateSelect from '@/modules/CMS/components/TemplateSelect'

export default {
  name: 'TemplateList',

  components: {
    TemplateSelect,
    ColorPicker,
    DatePicker
  },

  actionBar () {
    return {
      title: 'Template settings'
    }
  },

  data () {
    return {
      settings: [],
      templates: [],
      template: null,
      menu: [],
      loadingField: null
    }
  },

  watch: {
    async template (val) {
      let res = await this.$http.make('template_settings').limit(-1).getFullData({ headers: { 'x-template-code': val } })
      this.settings = res.collection
    }
  },

  async mounted () {
    const res = await this.$http.make('template').limit(-1).getFullData()
    this.templates = res.collection

    if (!this.templates.length) {
      return
    }

    this.template = this.templates[0].code
  },

  methods: {
    async save (id, value, label) {
      try {
        this.loadingField = id
        await this.$http.make('template_settings').updateValue(id, value, {
          headers: { 'x-template-code': this.template }
        })
        this.$toast.success(`${label} has been updated`)
      } finally {
        this.loadingField = null
      }
    }
  }
}
</script>
